const AddIcon = () => (
  <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Add">
      <path
        id="Vector"
        d="M8 14.75C8 14.9489 8.07902 15.1397 8.21967 15.2803C8.36032 15.421 8.55109 15.5 8.75 15.5C8.94891 15.5 9.13968 15.421 9.28033 15.2803C9.42098 15.1397 9.5 14.9489 9.5 14.75V9.5H14.75C14.9489 9.5 15.1397 9.42098 15.2803 9.28033C15.421 9.13968 15.5 8.94891 15.5 8.75C15.5 8.55109 15.421 8.36032 15.2803 8.21967C15.1397 8.07902 14.9489 8 14.75 8H9.5V2.75C9.5 2.55109 9.42098 2.36032 9.28033 2.21967C9.13968 2.07902 8.94891 2 8.75 2C8.55109 2 8.36032 2.07902 8.21967 2.21967C8.07902 2.36032 8 2.55109 8 2.75V8H2.75C2.55109 8 2.36032 8.07902 2.21967 8.21967C2.07902 8.36032 2 8.55109 2 8.75C2 8.94891 2.07902 9.13968 2.21967 9.28033C2.36032 9.42098 2.55109 9.5 2.75 9.5H8V14.75Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default AddIcon;
